import React from 'react';
import MiddleImage from '../../../img/MainWebsite/HomePage2.png';
import { Link, useNavigate } from 'react-router-dom';

function MainContent() {

  const navigate = useNavigate();
  return (
    <main >
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link href="https://fonts.googleapis.com/css2?family=Courgette&display=swap" rel="stylesheet"></link>
      <h1 className="font-courgette">A Better Golf Experience</h1>
      <div className={''}>
        <img src={MiddleImage} className={' home-image image-border'} alt="Image 2" />
      </div>
    </main>
  );
}

export default MainContent;